import { ToxicityLabelEnum } from "submodules/nerit-aquatec-sdk/services/charts/enums/ToxicityEnum";
import { ThemeProject } from 'config/theme/project/ThemeProject'
import styled from "styled-components";
import React from "react";

interface IContaminationRow {
  label: ToxicityLabelEnum
  gap: string
  color: string
}

const ContaminationRow: IContaminationRow[] = [
  {
    label: ToxicityLabelEnum.NO_CONTAMINATION,
    gap: "Concentração <= 1,2 Limite",
    color: ThemeProject.success
  },
  {
    label: ToxicityLabelEnum.MEDIUM_CONTAMINATION,
    gap: "1,2 Limite < Concentração <= 2,0 Limite",
    color: ThemeProject.warning
  },
  {
    label: ToxicityLabelEnum.HIGH_CONTAMINATION,
    gap: "Concentração > 2,0 Limite",
    color: ThemeProject.error
  }
]

const WaterContaminationTable = styled.table`
  width: 45vw;
  border: solid 2px;
  text-align: center;
  margin-bottom: 10px;

  th, td {
    border: solid 1px;
  }
`
const WaterContaminationTHRow = styled.tr`
  background-color: ${ThemeProject.gray100};
`
const WaterContaminationCell = styled.td<{$color: string}>`
  background-color: ${(props) => props.$color};
`

export const TableCaptionWaterContaminationChartCP = () => {
  return (
    <WaterContaminationTable>
      <thead>
        <WaterContaminationTHRow>
          <th>Enquadramento da classe de contaminação</th>
          <th>Concentração em relação à norma de referência</th>
        </WaterContaminationTHRow>
      </thead>
      <tbody>
        {ContaminationRow.map((i) => (
        <tr key={i.label}>
          <WaterContaminationCell $color={i.color}>{i.label}</WaterContaminationCell>
          <td>{i.gap}</td>
        </tr>
        ))}
      </tbody>
    </WaterContaminationTable>
  )
}